import style from "./style.module.css"
import LoginBanner from "../../assets/login-banner.svg"
import CollegeLogo from "../../assets/college-logo.png"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { LoginAction } from "../../redux/actions/AuthActions"
import { toast } from "react-toastify"
import { Helmet } from "react-helmet";


const Login = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [uid, setUid] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const submit = (e) => {
        e.preventDefault()
        setIsLoading(true)
        const userData = {
            uid
        }
        dispatch(LoginAction(userData, navigate, toast, setIsLoading))
    }
    return (
        <div className={style.mainDiv}>

            <Helmet>
                <title>Login | Secure Examination</title>
            </Helmet>
            <div className={style.imageWrapper}>
                <img className={style.imageStyle} src={LoginBanner} alt="..." />
            </div>
            <form onSubmit={(e) => submit(e)} className={style.rightSectionWrapper}>
                <div className={style.loginWrapper}>
                    <img className={style.collegeLogo} src={CollegeLogo} alt="..." />
                    <p className={style.instituteName}>Padmashri Annasaheb Jadhav Bharatiya Samaj Unnati Mandal’s</p>
                    <p className={style.collegeName}>B. N. N. College of Arts, Science & Commerce, Bhiwandi.</p>
                    <h3 className={style.loginHeader}>Login</h3>
                    <p className={style.loginMsg}>Welcome student. Please login with your UID.</p>
                    <div className={style.loginInputsWrapper}>
                        <div className={style.inputWrapper}>
                            <p className={style.inputLabel}>UID:</p>
                            <input value={uid} onChange={(e) => setUid(e.target.value)} className={style.inputTag} placeholder="Enter your UID" />
                        </div>
                        <div className={style.btnsWrapper}>
                            {
                                isLoading
                                    ?
                                    <button className={style.loginBtn} type="button">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </button>
                                    :
                                    <button className={style.loginBtn} type="submit">Login</button>
                            }
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Login;